import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMunsell = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 8.7,
			height: 8.7,
			x: 3,
			y: 3,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8.7,
			height: 8.7,
			x: 14.1,
			y: 3,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8.7,
			height: 8.7,
			x: 3,
			y: 14.1,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8.7,
			height: 8.7,
			x: 14.1,
			y: 14.1,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8.7,
			height: 8.7,
			x: 25.2,
			y: 14.1,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8.7,
			height: 8.7,
			x: 36.3,
			y: 14.1,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8.7,
			height: 8.7,
			x: 3,
			y: 25.2,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8.7,
			height: 8.7,
			x: 14.1,
			y: 25.2,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8.7,
			height: 8.7,
			x: 25.2,
			y: 25.2,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8.7,
			height: 8.7,
			x: 3,
			y: 36.3,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 8.7,
			height: 8.7,
			x: 14.1,
			y: 36.3,
			rx: 1.2
		})
	]
});
export default SvgMunsell;
